var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialTwitter = function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 6.2c-.5.2-1 .4-1.5.4.5-.4.9-.9 1.1-1.4-.5.2-1 .5-1.6.6-.3-.4-1.1-.8-1.8-.8-1.6 0-2.9 1.5-2.5 3.1-2.1 0-4-1-5.2-2.6-.7 1.1-.5 2.6.8 3.5-.5-.1-.9-.2-1.3-.4 0 1.2.9 2.2 2 2.5-.2.1-.6.1-1.1.1.4 1 1.2 1.8 2.4 1.8-1.1.9-2.4 1.2-3.8 1 1.1.8 2.5 1.1 3.9 1.1 4.8 0 7.5-4 7.2-7.6.7-.3 1.1-.7 1.4-1.3z"
  })));
};
export default SvgSocialTwitter;